import Cookies from 'js-cookie'

/**
 * 设置语言 Cookie，同步到顶级域以共享跨子域语言
 * @param {string} val - 语言值，如 'cn_CN' / 'en_CN'
 */
export const setLangCookies = val => {
  Cookies.set('__lclcookie', val, { domain: '.cdnetworks.com' })
  Cookies.set('service_language', val === 'cn_CN' ? 'zh-cn' : 'en', { domain: '.cdnetworks.com' })
}
